import { render, staticRenderFns } from "./modules2.vue?vue&type=template&id=460c7f95&scoped=true"
import script from "./modules2.vue?vue&type=script&lang=js"
export * from "./modules2.vue?vue&type=script&lang=js"
import style0 from "./modules2.vue?vue&type=style&index=0&id=460c7f95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460c7f95",
  null
  
)

export default component.exports